const forms = [
  {
    name: "Details",
    options: [
      {
        name: "Account Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Enter account name",
          value: "",
          required: true,
        },
      },
      {
        name: "Account Code",
        type: "input",
        form: {
          type: "text",
          name: "code",
          placeholder: "Enter account code",
          value: "",
          required: true,
        },
      },
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Optional account description",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Classification",
    options: [
      {
        name: "Account Type",
        type: "select",
        form: {
          name: "account_type",
          placeholder: "Select type",
          allowClear: true,
          options: [
            "Bank & Cash",
            "Current Asset",
            "Depreciation",
            "Fixed Asset",
            "Inventory",
            "Non-current Asset",
            "Prepayment",
            "Equity",
            "Direct Costs",
            "Expense",
            "Other Income",
            "Income",
            "Revenue",
            "Sales",
            "Current Liability",
            "Liability",
            "Non-current Liability",
          ].map((type) => ({
            value: type,
            label: type,
          })),
          value: null,
          required: true,
        },
      },
      {
        name: "Account Category",
        type: "select",
        form: {
          name: "category",
          placeholder: "Select category",
          allowClear: true,
          options: [
            "Assets",
            "Liabilities",
            "Equity",
            "Expenses",
            "Income",
          ].map((category) => ({
            value: category,
            label: category,
          })),
          value: null,
          required: true,
        },
        onChange: (value, form, setForm) => {
          // Find the associated accounts field and update its category
          const updatedForm = form.map((section) => {
            if (section.name === "Flags") {
              return {
                ...section,
                options: section.options.map((option) => {
                  if (option.form?.name === "associatedaccounts") {
                    return {
                      ...option,
                      form: {
                        ...option.form,
                        category: value, // Set the category for associated accounts
                      },
                    };
                  }
                  return option;
                }),
              };
            }
            return section;
          });
          setForm(updatedForm);
        },
      },
    ],
  },
  {
    name: "Flags",
    options: [
      {
        name: "Is Contra Account",
        type: "checkbox",
        form: {
          name: "isContraAccount",
          value: false,
          required: false,
        },
      },
      {
        name: "Associated Accounts",
        type: "select",
        form: {
          name: "associatedaccounts",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Associated Accounts",
          api: "get-all-accounts",
          source: "ChartOfAccount",
          category: null,
          options: null,
          value: null,
          required: false,
        },
        conditional: {
          field: "isContraAccount",
          value: true,
        },
      },

      {
        name: "Is Accounts Receivable",
        type: "checkbox",
        form: {
          name: "isReceivable",
          value: false,
          required: false,
        },
      },
      {
        name: "Is Accounts Payable",
        type: "checkbox",
        form: {
          name: "isPayable",
          value: false,
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          value: 1,
          placeholder: "Status",
          options: [
            { value: 1, label: "Active" },
            { value: 0, label: "Inactive" },
          ],
          required: true,
        },
      },
    ],
  },
];

export default forms;
